import React, { useState, useEffect } from 'react';
import { Link, NavLink, useLocation } from 'react-router-dom';
import logo from '../assets/logo.png';
import './Navbar.css';

const NAV_ITEMS = [
  { label: 'Home', to: '/' },
  { label: 'About', to: '/about' },
  { label: 'Programs', to: '/programs' },
  { label: 'Impact', to: '/impact' },
  { label: 'Gallery', to: '/gallery' },
  { label: 'Contact', to: '/contact' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 30);
    window.addEventListener('scroll', onScroll, { passive: true });
    onScroll();
    return () => window.removeEventListener('scroll', onScroll);
  }, []);

  useEffect(() => {
    setMenuOpen(false);
    document.body.style.overflow = '';
  }, [location]);

  const toggleMenu = () => {
    setMenuOpen(prev => {
      document.body.style.overflow = !prev ? 'hidden' : '';
      return !prev;
    });
  };

  const navClass = `navbar ${scrolled ? 'navbar-scrolled' : 'navbar-transparent'}`;

  return (
    <>
      <nav className={navClass} role="navigation" aria-label="Main navigation">
        <div className="container navbar-inner">
          <Link to="/" className="navbar-logo" aria-label="Shine People Trust Home">
            <img src={logo} alt="Shine People Charitable Trust" className="logo-img" />
          </Link>

          <ul className="nav-links">
            {NAV_ITEMS.map(item => (
              <li key={item.to}>
                <NavLink
                  to={item.to}
                  className={({ isActive }) => `nav-link${isActive ? ' active' : ''}`}
                  end={item.to === '/'}
                >
                  {item.label}
                </NavLink>
              </li>
            ))}
          </ul>

          <div className="nav-cta">
            <a href="https://grantalife.com/" target="_blank" rel="noopener noreferrer" className="btn btn-secondary btn-sm">
              Get Involved
            </a>
            <button
              className={`hamburger${menuOpen ? ' open' : ''}`}
              onClick={toggleMenu}
              aria-expanded={menuOpen}
              aria-label={menuOpen ? 'Close menu' : 'Open menu'}
            >
              <span />
              <span />
              <span />
            </button>
          </div>
        </div>
      </nav>

      <div className={`mobile-menu${menuOpen ? ' open' : ''}`} role="dialog" aria-modal="true" aria-label="Mobile navigation">
        <button className="mobile-close" onClick={toggleMenu} aria-label="Close menu">✕</button>
        <ul className="mobile-nav-links">
          {NAV_ITEMS.map(item => (
            <li key={item.to}>
              <NavLink
                to={item.to}
                className={({ isActive }) => `mobile-nav-link${isActive ? ' active' : ''}`}
                end={item.to === '/'}
              >
                {item.label}
              </NavLink>
            </li>
          ))}
        </ul>
        <div className="mobile-divider" />
        <div className="mobile-cta">
          <a href="https://grantalife.com/" target="_blank" rel="noopener noreferrer" className="btn btn-primary">Get Involved</a>
          <Link to="/contact" className="btn btn-outline">Contact Us</Link>
        </div>
      </div>
    </>
  );
}
